import { useSearchParams } from 'react-router-dom';

import { MP_KEY_SUBSCRIPTION } from 'constants/env-variables';

export const useSubscriptionId = () => {
  const [searchParams] = useSearchParams();

  return searchParams.get(MP_KEY_SUBSCRIPTION) as string;
};
